// export const baseUrl = "http://localhost:5000"; //testing
// export const baseUrl="http://localhost:3306" //testing

export const baseUrl = "https://uat.dreamdor.com";
export const redirectUrl = "https://websiteuat.dreamdor.com";

// export const baseUrl = "https://api.dreamdor.com"; //PRODUCTION
// export const redirectUrl = "https://dreamdor.com"; //PRODUCTION


export const counselorId = 85